import styled from 'styled-components';
import { palette } from 'styled-tools';

export const Wrapper = styled.section`
	color: ${palette('white')};
	padding: 100px 0 60px;
	position: relative;
	text-align: center;
`;

export const Heading = styled.h2`
	margin-bottom: 20px;
`;
